import { useSearchParams } from 'react-router-dom';
import { ModalProps } from '../../../../../../components/modal/modal';
import { useLang } from '../../../../../../hooks/use-lang';
import { useExternalReviewsStore } from '../../../../../../store/use-external-reviews-store';

export const useDeleteExternalReviewModal = (props: ModalProps) => {
  const { t } = useLang();
  const { externalReviews, deleteExternalReview, isLoadingAction } = useExternalReviewsStore();
  const [searchParams] = useSearchParams();
  const reviewId = searchParams.get('reviewId');

  const review = externalReviews?.find((item) => String(item.id) === reviewId);
  const reviewUrl = review?.url || '';

  const handleDelete = async () => {
    if (!reviewId) return;

    try {
      await deleteExternalReview(Number(reviewId));
      props.onClose();
    } catch (e) {
      // Ошибка обрабатывается в store
    }
  };

  return {
    t,
    handleDelete,
    isLoading: isLoadingAction,
    reviewUrl,
  };
};
